module.exports = __webpack_public_path__ + "static/media/VattenfallHall-Bold.dbb27703.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/VattenfallHall-Bold.woff
// module id = 134
// module chunks = 0